import styled from 'styled-components'

type IconsProps = {
    $color: string,
    $hoverColor: string,
    $mobileColor: string
    $small?: boolean,
    $isOlymps?: boolean
}

export const Icons = styled.div<IconsProps>`
    margin-top: .22em;
    display: flex;
    height: 1.6667em;
    
    &&>a {
        color: rgba(0, 0, 0, 0.87);
        display: block;
    }
    &&>a>div {
        font-size: ${({ $small }) => $small ? '15px' : '18px'};
        border: ${({ $small }) => $small ? '2px' : '1px' } solid rgba(255,255,255,.9);
        color: ${({ $color }) => $color || '#000'};
        border-color: ${({ $color }) => $color || '#000'};
        fill: ${({ $color }) => $color || '#000'};

        i.icon {
            margin: ${({ $small }) => $small ? '.3em' : '.35em'} auto;
            padding-right: 3px;
        }
    }
    &&>a>div * {
        fill: ${({ $color }) => $color || '#000'};
    }
    @media (max-width: 767px) {
        height: 1.8889em;

        &&&>a>div {
            font-size: ${({ $small }) => !$small && '1.09091em'};
        }
        &&&>a>div, &&&>a>div * {
            color: ${({ $mobileColor }) => $mobileColor || '#000'};
            border-color: ${({ $mobileColor }) => $mobileColor || '#000'};
            fill: ${({ $mobileColor }) => $mobileColor || '#000'};
        }
    }
    &&>a:hover *, &&>a:hover>div, &&>a:hover>div * {
        color: ${({ $hoverColor }) => $hoverColor || '#000'};
        border-color: ${({ $hoverColor }) => $hoverColor || '#000'};
        fill: ${({ $hoverColor }) => $hoverColor || '#000'};
    }
    &&>a:hover>div {
        ${({ $isOlymps }) => $isOlymps && 'transform: scale(1.1)'};
    }
`
export const Circle = styled.div`
    width: 1.7333em;
    height: 1.7333em;
    display: inline-grid;
    border-radius: 50%;
    margin-right: .5em;
`

export const RutubeIconWrapper = styled.div`
    margin: 0 auto;
    line-height: 1.8em;
    & svg {
        margin-left: 1px;
        width: .9em;
        height: .9em;
    }
`
